<template>
  <div class="container">
       <div id="chartdiv">
 <timechart v-if="loaded" :chartdata="chartdata" :options="options" :chart-id="myID"/>
 </div>
    <p style="font-size:14px" v-if="filterText!=''">{{filterText}}</p>
    <p style="font-size:12px" v-if="showDateRange"> <a href="#daterange" class="card-link">Click here to specify custom Date Range for chart</a><span v-if="(start_date != start_date_min) || (end_date != end_date_max)">. Custom Date Range in effect.  </span> </p>
  </div>
</template>

<script>
import TimeChart from "./TimeChart.js";
import { API } from "aws-amplify";

export default {
  name: "TimeChartRACContainer",
  components: {
    timechart: TimeChart
  },
  props: ["collection_id", "collection_type", "user", "chart_id", "label", "stacked",  "num_instances", "consolidated_databases_num", "consolidated_databases_list", "targets", "targetValues", "adjustment", "colorScheme", "filter", "instancenum_list", "start_date", "end_date", "start_date_min", "end_date_max", "showDateRange"],
  data: () => ({
    loaded: false,
    working_num_instances: null,
    working_fill: false,
    working_label: "",
    chartdata: null,
    maindata: null,
    newdata: null,
    myID: "dave3",
    filterText: "Chart loading...",    
    options: {
      bezierCurve : false,
      elements: {
        line: {
          tension: 0
        }
      },
      scales: {
        xAxes: [
          {
            type: "time",
            time: {
              unit: 'day',
                    displayFormats: {
           'millisecond': 'MMM DD',
           'second': 'MMM DD',
           'minute': 'MMM DD',
           'hour': 'MMM DD',
           'day': 'MMM DD',
           'week': 'MMM DD',
           'month': 'MMM DD',
           'quarter': 'MMM DD',
           'year': 'MMM DD'
                    }
                }
          }
        ],
        yAxes: [
          { 
            id: 'y-axis-0',
            stacked: true
          }
        ]
      },
      responsive: true,
      maintainAspectRatio: false,
      gradient: null,
      gradient2: null,
      annotation: {
        annotations: [
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 220,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: 'Max'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 180,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '99%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 140,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '95%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 100,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '90%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4.5,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 60,
              content: 'Avg',
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 0,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: 'Median'
            }  
          }
          
        ]
      }
      

    }
  }),
  async mounted() {
    this.loaded = false;
    this.working_label = this.label;
    
    //is this Consolidated or RAC
    if (this.consolidated_databases_num*1 > 0) {
      this.working_num_instances = this.consolidated_databases_num;
      this.working_fill=true;
      this.working_label="DB";
    }  else {
      this.working_num_instances = this.num_instances;
    }  
    
    
    this.myID = this.chart_id;
    if ((this.myID=="IO_MBS_AVGPEAK")&&( (this.adjustment!=undefined) && (this.adjustment*1!=0)&&(this.adjustment*1!=1))) {
      this.myID="IO_MBS_AVGPEAKADJ";
    }
    if ((this.myID=="IOPS_AVGPEAK")&&( (this.adjustment!=undefined) && (this.adjustment*1!=0)&&(this.adjustment*1!=1))) {
      this.myID="IOPS_AVGPEAKADJ";
    }
    // this.myID="RACCPU";

     //keep this stacked=true if this is a consolidated database chart
     if ( (this.stacked=="false") && !(this.consolidated_databases_num*1>0) ) {
       this.options.scales.yAxes[0].stacked = false;
     }  


    try {
      // console.log("TCC2: I am here");
      let sorted = [];
      let total_val = 0;
      let current_val = 0;
      let filterCount = 0;
      
      if (this.maindata == null) {
        var new_collection_id = this.collection_id;

        this.newdata = [[]];
         for (var inst2 = 1; inst2 < this.working_num_instances; inst2++ ) {
           this.newdata.push([]);
         }   
        
        
        var labels=[];
        var borderColors=["rgba(0, 128, 0, 1)", 
        "#ff0000",
        "rgba(0, 0, 255, 1)", 
        "#FFA500",
        "rgba(194, 183, 155, 1)", 
        "rgba(0, 128, 128, 1)",
        "#FFFF00",
        "#800080", "rgba(128, 128, 0, 1)",  "#000000"];
        var backgroundColors=["rgba(0, 128, 0, 0.25)", 
        "rgba(255, 0,0, 0.25)",
        "rgba(0, 0, 255, 0.25)", 
        "rgba(255, 165, 0, 0.25)",
        "rgba(194, 183, 155, 0.25)", 
        "rgba(0, 128, 128, 0.25)",
        "rgba(255, 255, 0, 0.25)",
        "rgba(128, 0, 128, 0.25)", 
        "rgba(128, 128, 0, 0.25)",  
        "rgba(0, 0, 0, 0.25)"];
         borderColors=["rgba(194, 183, 155, 1)", "#ff0000","rgba(0, 128, 128, 1)","#FFFF00","#FFA500","#800080", "rgba(0, 0, 255, 1)","rgba(0, 255, 0, 1)","rgba(128, 128, 0, 1)"];
         backgroundColors=["rgba(194, 183, 155, 0.25)", "rgba(255, 0,0, 0.25)","rgba(0, 128, 128, 0.25)","#FFFF00","#FFA500","#800080", "rgba(0, 0, 255, 0.25)","rgba(0, 255, 0, 0.25)","rgba(128, 128, 0, 0.25)"];
        
        this.chartdata = {
        datasets: [
          {
            label: labels[0],
            data: this.newdata[0],
            borderColor: borderColors[0],
            backgroundColor: backgroundColors[0],
            borderWidth: 1,
            pointRadius: 1,
            fill: this.working_fill
          // borderColor: '#FC2525',
          // pointBackgroundColor: 'white',
          // borderWidth: 1,
          // pointBorderColor: 'white'
          // backgroundColor: this.gradient
          }
          ]
        };
        
        for (var inst = this.working_num_instances; inst > 0; inst--) {
          
          var instlabel='';
          var instid = '';
          
          if (this.instancenum_list!=undefined && this.instancenum_list!='undefined' && this.instancenum_list!='') {
            // console.log("TCRAC",this.instancenum_list);
            if (this.consolidated_databases_num*1>0) {
              instlabel=this.consolidated_databases_list.split(',')[inst-1];
            } else {  
              instlabel=this.instancenum_list.split(',')[inst-1];
            }  
            instid=this.instancenum_list.split(',')[inst-1];
          } else {
            instlabel=inst;
            instid=inst;
          }  
          new_collection_id = this.collection_id+'-'+instid;
          // console.log("new_collection_id", new_collection_id);
          
          var tries = 2;
          while (tries > 0) {
            filterCount = 0;
            await API.get("dbcsiAPI", `/dbcsi/${new_collection_id}/${this.collection_type}/${this.chart_id}`)
              .then(response => {
                // console.log("TCC2: I am here3");
                this.maindata = response.data;
                
  
                filterCount = 0;
                
                labels[inst-1] = this.working_label.split(":")[0]+"["+instlabel.trim()+"]";
  
              if (this.start_date) {
                // console.log("start_date", this.start_date, this.maindata.length, this.maindata[0].x);
                this.maindata = this.maindata.filter((row) => row.x >= this.start_date);
                // console.log("start_date AFTER", this.start_date, this.maindata.length, this.maindata[0].x);
              }
              
              if (this.end_date) {
                // console.log("end_date", this.end_date, this.maindata.length, this.maindata[0].x);
                this.maindata = this.maindata.filter((row) => row.x <= (this.end_date+" 23:59:59") );
                // console.log("end_date AFTER", this.end_date, this.maindata.length, this.maindata[0].x);
              }

                for (var ii = 0; ii < this.maindata.length; ii++) {
                  
                  if ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y*1<this.filter*1)) ) {
                    //we are not using a filter or we meet the filter
                  
                    if (((this.chart_id=="CPUAVGPEAK")||(this.chart_id=="IO_MBS_AVGPEAK")||(this.chart_id=="IOPS_AVGPEAK")||(this.chart_id=="PDB_IOPS")||(this.chart_id=="PDB_CPU_USAGE_PER_S")||(this.chart_id=="PDB_IOMBPS")||(this.chart_id=="cpu_per_s")||(this.chart_id=="cpu_per_s_max")||(this.chart_id=="MAIN_METRICS~cpu_per_s")||(this.chart_id=="MAIN_METRICS~PDB_CPU_USAGE_PER_S")) && 
                            (this.adjustment!=undefined)&&(this.adjustment*1!=0)&&(this.adjustment*1!=1)) {
                      this.newdata[inst-1].push({
                        x: this.maindata[ii].x,
                        y: this.maindata[ii].y/(this.adjustment*1)
                      });
                      current_val=Number(this.maindata[ii].y/(this.adjustment*1));
                      // console.log("adjustment", this.adjustment);
                    } else {  
                      this.newdata[inst-1].push({
                        x: this.maindata[ii].x,
                        y: this.maindata[ii].y
                      });
                      current_val=Number(this.maindata[ii].y);
                    }
                 
                    //calculate statistics
                    
                    total_val = total_val + current_val;
                    sorted.push(current_val);
                  }  else {
                    filterCount++;
                  }
                }

  
                tries = 0;
                // console.log(this.newdata[0]);
              })
              .catch(error => {
                console.log("TCC2 Error:", error);
              });
            tries -= 1;
          }
          

        } //end loop
        // console.log("newdata", this.newdata);
        // console.log("chartdata", this.chartdata);
      }


      this.chartdata = {
        datasets: [
          {
            label: labels[0],
            data: this.newdata[0],
            borderColor: borderColors[0],
            backgroundColor: borderColors[0],
            borderWidth: 1,
            pointRadius: 1,
            fill: this.working_fill
          // borderColor: '#FC2525',
          // pointBackgroundColor: 'white',
          // borderWidth: 1,
          // pointBorderColor: 'white'
          // backgroundColor: this.gradient
          } ] };
      // console.log("chart datasets length0", this.chartdata.datasets.length);
      if (this.working_num_instances>1) {
        for (var inst2 = 1; inst2 < this.working_num_instances; inst2++ ) {
          this.chartdata.datasets.push({
              label: labels[inst2],
              data: this.newdata[inst2],
              borderColor: borderColors[inst2],
              backgroundColor: borderColors[inst2],
              borderWidth: 1,
              pointRadius: 1,            
              fill: this.working_fill
            });
        }    
      }    
      
      // console.log("chart datasets length1", this.chartdata.datasets.length);
         
      
      if (filterCount>0) {
        this.filterText = "Note: "+filterCount+" data points (out of "+this.maindata.length+") were filtered from the chart because they were above the expected reasonable value of "+(this.filter*1).toFixed(0);
        // console.log("filterText tc2c", this.filterText);
      } else {
        this.filterText = "";
      }
      
  /*
     if (this.colorScheme=="adhoc2") {
        this.chartdata.datasets[0].fill = false;
        this.chartdata.datasets[1].borderColor = "#3e95cd";
        this.chartdata.datasets[1].backgroundColor = "#3e95cd";
        this.chartdata.datasets[1].fill = false;
      }
      
      //TODO: if chart is IO_MBS_RW or IO_MBS_RW_MAX, then change backgroundColor
      //            borderColor: "rgba(0, 255, 0, 1)",
      //      backgroundColor: "rgba(0, 255, 0, 0.25)",
      //            borderColor: "rgba(0, 128, 128, 1)",
      //      backgroundColor: "rgba(0, 128, 128, 0.25)",
      if ((this.chart_id=="IO_MBS_RW")||(this.chart_id=="IO_MBS_RW_MAX")||(this.chart_id=="EXADATA3")) {
        this.chartdata.datasets[0].borderColor = "rgba(0, 200, 80, 1)";
        this.chartdata.datasets[0].backgroundColor = "rgba(0, 200, 80, 0.25)";
        this.chartdata.datasets[1].borderColor = "rgba(0, 128, 128, 1)";
        this.chartdata.datasets[1].backgroundColor = "rgba(0, 128, 128, 0.25)";
         
      }
      if ((this.chart_id=="EXADATA2")) {
        this.chartdata.datasets[0].borderColor = "orange";
        this.chartdata.datasets[0].backgroundColor = "orange";
      }
      if ((this.chart_id=="CPUAVGPEAK")||(this.chart_id=="IOPS_AVGPEAK")||(this.chart_id=="IO_MBS_AVGPEAK")) {
        // this.chartdata.datasets[1].borderColor = "brown";
        // this.chartdata.datasets[1].backgroundColor = "tan";
        // 217, 206, 178
        this.chartdata.datasets[1].borderColor = "rgba(194, 183, 155, 1)";
        this.chartdata.datasets[1].backgroundColor = "rgba(194, 183, 155, 0.25)";
         
      }
      if ((this.chart_id=="MEMORY")) {
        //. 64, 185, 230. 33, 237, 234. 67, 222, 121
        this.chartdata.datasets[0].borderColor = "rgba(33, 237, 234, 1)";
        this.chartdata.datasets[0].backgroundColor = "rgba(33, 237, 234, 0.6)";
      }
  */



      //done
    

       //if targets
       if (this.targets == undefined) {
         this.options.annotation = {};
       } else
       {
         let targetArr = this.targets.split(":");
         for (var ii = 0; ii < targetArr.length; ii++) {
           this.options.annotation.annotations[ii].label.content=targetArr[ii];
           this.options.annotation.annotations[ii].value=this.targetValues.split(":")[ii];
           //console.log(this.options.annotation.annotations[ii].label.content,this.options.annotation.annotations[ii].value);
         }
         //fix label offsets
         this.options.annotation.annotations[0].label.xAdjust=0;
         this.options.annotation.annotations[1].label.xAdjust=300;
         this.options.annotation.annotations[2].label.xAdjust=400;
         this.options.annotation.annotations[3].label.xAdjust=500;
         this.options.annotation.annotations[4].label.xAdjust=600;
         this.options.annotation.annotations[5].label.xAdjust=700;
        // this.options.annotation.annotations[1].label.xAdjust=100;
        // this.options.annotation.annotations[2].label.xAdjust=200;
        // this.options.annotation.annotations[3].label.xAdjust=300;
        // this.options.annotation.annotations[4].label.xAdjust=400;
        // this.options.annotation.annotations[5].label.xAdjust=500;

         this.options.annotation.annotations[0].label.yAdjust=5;
         this.options.annotation.annotations[1].label.yAdjust=5;
         this.options.annotation.annotations[2].label.yAdjust=5;

         this.options.annotation.annotations[0].borderDash = [5, 15];
         
         // clear out remaining annotations
         this.options.annotation.annotations.splice(targetArr.length,6-targetArr.length);
         
       }   
      

    
      this.loaded = true;
    } catch (e) {
      console.error(e);
    }
  }
};
</script>